module.exports = __webpack_public_path__ + "img/pinduoduo.a7205701.png";